import React, { useEffect, useState } from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import { CircularProgress, LinearProgress } from "@material-ui/core";
import { invokeApi } from "../../bl_libs/invokeApi";
import { number } from "prop-types";
import {
  googleBtnImage,
  facebookBtnImage,
  greyBackArrowImage,
  infoIconImage,
} from "../../assets";
import NumberFormat from "react-number-format";
import ReactPasswordStrength from "react-password-strength";
import { validatePasswordStrength } from "../../ui_libs/Validations/validations";
import PhoneVarification from "./components/PhoneVarification";
import { useSnakbar } from "../../Context/Context-Snakbar/ContextSnackbar";
import { useSockets } from "../../Context/Context-Sockets/ContextSockets";
import EmailVarification from "./components/EmailVarification";
import FacebookAuth from "./components/FacebookAuth";
import GoogleAuth from "./components/GoogleAuth";
import PhoneNumberScreen from "./components/PhoneNumberScreen";
import Tippy from "@tippy.js/react";
function Register(props) {
  const { socketON } = useSockets();

  // if it comes from new request screen-------------------------
  const { reqPostData, setConfirmScreen, isDirectRequest } = props;
  //--------------------------------------------------------------

  const [inputs, setInputs] = React.useState({
    first_name: "",
    last_name: "",
    // phone: "",
    email: "",
    password: "",
    how_found_us: "facebook",
    reference_code: props.match?.params.reff ? props.match?.params.reff : "",
  });

  const { showErrorSnak, showSuccessSnak } = useSnakbar();

  //varification checks
  const [isVarified, setIsVarified] = React.useState(false);

  const [openPhoneScreen, setOpenPhoneScreen] = React.useState(false);

  const [openEmailScreen, setOpenEmailScreen] = React.useState(false);

  const [openPhoneNumberScreen, setOpenPhoneNumberScreen] =
    React.useState(false);

  //Error message status

  const [errMessage, setErrMessage] = React.useState("");
  const [successMessage, setSuccessMessage] = React.useState("");

  const [passStrength, setPassStrength] = React.useState({
    color: "",
    strength: "",
    level: 0,
  });

  const [auth, setAuth] = useState();

  const [isLoading, setIsLoading] = React.useState(false);

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };
  const validPhoneNumber = (phone) => {
    const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
    return re.test(phone);
  };

  const validString = (string) => {
    const re = /^[a-z A-Z]+$/;
    return re.test(string);
  };
  const alphaNumeric = (txt) => {
    var letterNumber = /^[0-9a-zA-Z]+$/;
    return letterNumber.test(txt);
  };

  const handleChange = (e) => {
    if (e.target.id === "password") {
      setPassStrength(validatePasswordStrength(e.target.value));
    }
    setInputs({
      ...inputs,
      [e.target.id]: e.target.value.trim(),
    });
  };

  const SendCodeOnPhone = () => {
    console.log("SendCodeOnPhone");
    let requestObj = {
      path: "/app_api/send_verification_code_on_ph_number",
      method: "POST",
      headers: {},
    };
    let postData = {
      phonenumber: `+1${inputs.phone}`,
      channel: "sms",
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        setOpenPhoneScreen(true);
        setIsLoading(false);
        showSuccessSnak("Phone verification code has been sent.");
        setErrMessage("");
      } else {
        setIsLoading(false);
        // setErrMessage(res.message);
        ////showErrorSnak(res.message);
      }
    });
  };

  const SendCodeOnEmail = () => {
    console.log("SendCodeOnEmail");
    let requestObj = {
      path: "/app_api/send_verification_code_on_email",
      method: "POST",
      headers: {},
    };
    let postData = {
      email: inputs.email.trim(),
      name: inputs.first_name + " " + inputs.last_name,
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        setOpenEmailScreen(true);
        setOpenPhoneScreen(false);
        setIsLoading(false);
        showSuccessSnak("Email verification code has been sent.");
        setErrMessage("");
      } else {
        // setErrMessage(res.message);
        ////showErrorSnak(res.message);
        setIsLoading(false);
      }
    });
  };

  // Post client request before entering in app
  const handleReqPostData = (token, user) => {
    let requestObj = {
      path: "/api/customer/generate_request",
      method: "POST",
      headers: {
        "x-sh-auth": token,
      },
    };
    let postData = reqPostData;
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));
        socketON();
        props.history.push("/dashboard/congratulations");
      }
    });
  };

  const handleSignUp = () => {
    //validation for first name
    if (!alphaNumeric(inputs.first_name) || !isNaN(inputs.first_name)) {
      setErrMessage("Please enter a valid first name.");
      return;
    } else if (inputs.first_name.length < 2) {
      setErrMessage("First name must have 2 characters");
      return;
    }

    //validation for last name
    if (!alphaNumeric(inputs.last_name) || !isNaN(inputs.last_name)) {
      setErrMessage("Please enter a valid last name.");
      return;
    } else if (inputs.last_name.length < 1) {
      setErrMessage("Last name must have 1 characters");
      return;
    }

    //validations step for phone number
    // if (inputs.phone[inputs.phone.length - 1] === "_") {
    //   setErrMessage("Please enter a valid phone number.");
    //   return;
    // }
    //validations step for email
    if (!validateEmail(inputs.email)) {
      setErrMessage("Please enter a valid email.");
      return;
    }
    //validations step for password
    if (inputs.password.length < 8) {
      setErrMessage("Minimum 8 characters required for password.");
      return;
    }
    if (passStrength.level < 3) {
      setErrMessage(
        "A minimum 8 characters password contains a combination of uppercase letter and number. And at least one special character are required."
      );

      return;
    }

    let requestObj = {
      path: "/api/customer/register_customer",
      method: "POST",
      headers: {},
    };
    let postData = inputs;
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        console.log(res);
        let storage_obj = {
          ...res.data,
          ...res.data.user,
        };

        if (reqPostData) {
          handleReqPostData(res.data.auth_token, storage_obj);
          return;
        }

        localStorage.setItem("token", res.data.auth_token);
        localStorage.setItem("user", JSON.stringify(storage_obj));
        props.history.push("/create-request");
        socketON();
      } else {
        setErrMessage(res.message);
        setIsLoading(false);
        localStorage.clear();
        console.log(res);
      }
    });
  };

  const checkEmailandPhone = () => {
    //validation for first name
    if (
      !alphaNumeric(inputs.first_name.trim()) ||
      !isNaN(inputs.first_name.trim()) ||
      !validString(inputs.first_name.trim())
    ) {
      setErrMessage("Please enter a valid first name.");
      showErrorSnak("Please enter a valid first name.");
      return;
    } else if (inputs.first_name.trim().length < 2) {
      setErrMessage("First name must have 2 characters");
      showErrorSnak("First name must have 2 characters");
      return;
    }

    //validation for last name
    if (
      !alphaNumeric(inputs.last_name.trim()) ||
      !isNaN(inputs.last_name.trim()) ||
      !validString(inputs.last_name.trim())
    ) {
      setErrMessage("Please enter a valid last name.");
      showErrorSnak("Please enter a valid last name.");
      return;
    } else if (inputs.last_name.trim().length < 1) {
      setErrMessage("Last name must have 1 characters");
      showErrorSnak("Last name must have 1 characters");
      return;
    }

    //validations step for phone number
    if (inputs.phone && inputs.phone[inputs.phone.length - 1] === "_") {
      setErrMessage("Please enter a valid phone number.");
      showErrorSnak("Please enter a valid phone number.");
      return;
    }
    //validations step for email
    if (!validateEmail(inputs.email.trim())) {
      setErrMessage("Please enter a valid email.");
      showErrorSnak("Please enter a valid email.");
      return;
    }
    //validations step for password
    if (inputs.password.length < 8) {
      setErrMessage("Minimum 8 characters required for password.");
      showErrorSnak("Minimum 8 characters required for password.");
      return;
    }
    if (passStrength.level < 3) {
      setErrMessage(
        "A minimum 8 characters password contains a combination of uppercase letter and number. And at least one special character are required."
      );
      showErrorSnak(
        "A minimum 8 characters password contains a combination of uppercase letter and number. And at least one special character are required."
      );
      return;
    }

    let requestObj = {
      path: "/app_api/validateEmailandPhone",
      method: "POST",
      headers: {},
    };
    let postData = {
      email: inputs.email.trim(),
      phone: inputs.phone,
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        setErrMessage("");
        // SendCodeOnPhone();
        SendCodeOnEmail();
      } else {
        setErrMessage(res.message);
        // //showErrorSnak(res.message);
        setIsLoading(false);
        localStorage.clear();
        console.log(res);
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    checkEmailandPhone();
    // handleSignUp();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (localStorage.getItem("token")) {
    return <Redirect to="/dashboard"></Redirect>;
  }

  if (isLoading) {
    return (
      <>
        <div className="Circular-Progress">
          <CircularProgress />
        </div>
      </>
    );
  }

  if (openEmailScreen) {
    return (
      <EmailVarification
        errMessage={errMessage}
        setErrMessage={setErrMessage}
        handleSignUp={handleSignUp}
        email={inputs.email}
        SendCodeOnEmail={SendCodeOnEmail}
        setOpenEmailScreen={setOpenEmailScreen}
      />
    );
  }

  if (openPhoneScreen) {
    return (
      <PhoneVarification
        phone={inputs.phone}
        setOpenPhoneScreen={setOpenPhoneScreen}
        SendCodeOnEmail={SendCodeOnEmail}
        SendCodeOnPhone={SendCodeOnPhone}
        errMessage={errMessage}
        setErrMessage={setErrMessage}
      />
    );
  }

  if (openPhoneNumberScreen) {
    return (
      <PhoneNumberScreen
        auth={auth}
        setOpenPhoneNumberScreen={setOpenPhoneNumberScreen}
        handleReqPostData={handleReqPostData}
        reqPostData={reqPostData}
      />
    );
  }
  return (
    <section className="main-content">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-xl-6 " id="register-error">
            {/* {errMessage && (
              <Alert variant="filled" severity="error">
                {errMessage}
              </Alert>
            )} */}
            {reqPostData && (
              <Alert variant="filled" severity="info">
                Your moving request has been saved. Please sign up or log into
                your account
              </Alert>
            )}
            <div className="form-box-wrapper">
              <div className="form-box">
                <h5 className="text-center">Sign Up</h5>
                <div className="social-login-wrapper pt-sm-3">
                  <div className="row justify-content-center text-center">
                    <div className="col-6 text-right p-0">
                      <GoogleAuth
                        setIsLoading={setIsLoading}
                        setOpenPhoneNumberScreen={setOpenPhoneNumberScreen}
                        setAuth={setAuth}
                        handleReqPostData={handleReqPostData}
                        reqPostData={reqPostData}
                      />
                    </div>
                    <div className="col-6 text-left p-0">
                      <FacebookAuth
                        setIsLoading={setIsLoading}
                        setOpenPhoneNumberScreen={setOpenPhoneNumberScreen}
                        setAuth={setAuth}
                        handleReqPostData={handleReqPostData}
                        reqPostData={reqPostData}
                      />
                    </div>
                  </div>
                  <div className="row text-center justify-content-center">
                    <div className="col-11 col-sm-9">
                      <div className="small-text-bold dark-grey-color text-divider">
                        <span>OR</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="evom-form login-form">
                  <form onSubmit={handleSubmit}>
                    <div className="row justify-content-center">
                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label
                            htmlFor="email"
                            className="overline dark-grey-color"
                          >
                            First Name
                          </label>
                          <input
                            required
                            value
                            type="text"
                            className="form-control small-font-size"
                            id="first_name"
                            value={inputs.first_name}
                            onChange={handleChange}
                            placeholder="John"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label
                            htmlFor="email"
                            className="overline dark-grey-color"
                          >
                            Last Name
                          </label>
                          <input
                            required
                            value={inputs.last_name}
                            type="text"
                            className="form-control small-font-size"
                            id="last_name"
                            onChange={handleChange}
                            placeholder="Doe"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label
                            htmlFor="email"
                            className="overline dark-grey-color"
                          >
                            Phone number (optional){" "}
                            <Tippy
                              content="By entering your phone number you will be getting all the latest updates related to your order, your phone # won't be used for any marketing, advertising."
                              delay={[300, 0]}
                              arrow={false}
                              placement="bottom"
                              maxWidth={200}
                            >
                              <img
                                width="18"
                                className="pointer-point"
                                src={infoIconImage}
                              />
                            </Tippy>
                          </label>
                          <NumberFormat
                            onChange={handleChange}
                            value={inputs.phone}
                            className="form-control small-font-size"
                            id="phone"
                            placeholder="(217) 555-0113"
                            format="(###) ###-####"
                            mask="_"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label
                            htmlFor="email"
                            className="overline dark-grey-color"
                          >
                            Email
                          </label>
                          <input
                            required
                            value={inputs.email}
                            onChange={handleChange}
                            type="email"
                            className="form-control small-font-size"
                            id="email"
                            placeholder="example@gmail.com"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label
                            htmlFor="email"
                            className="overline dark-grey-color"
                          >
                            Password
                          </label>
                          <input
                            required
                            value={inputs.password}
                            onChange={handleChange}
                            type="password"
                            className="form-control small-font-size"
                            id="password"
                            placeholder="*********"
                          />

                          {passStrength.level > 0 && (
                            <div
                              className="progress"
                              style={{ height: 2, marginTop: -3 }}
                            >
                              <div
                                className={
                                  "progress-bar " +
                                  ((passStrength.level < 2 && "bg-danger") ||
                                    // (passStrength.level === 2 && "bg-info") ||
                                    (passStrength.level === 3 &&
                                      inputs.password.length >= 8 &&
                                      "bg-success"))
                                }
                                role="progressbar"
                                style={{
                                  width: passStrength.level * 33.3333 + "%",
                                }}
                                aria-valuenow={passStrength.level}
                                aria-valuemin="0"
                                aria-valuemax="3"
                              ></div>
                            </div>
                          )}
                        </div>
                      </div>
                      {!isDirectRequest && (
                        <div className="col-12 col-sm-6">
                          <div className="form-group">
                            <label
                              htmlFor="company_name"
                              className="overline dark-grey-color"
                            >
                              Where Did You Find Us
                            </label>
                            <select
                              className="form-control small-font-size"
                              name="where_did_you_find"
                              value={inputs.how_found_us}
                              onChange={handleChange}
                              id="how_found_us"
                            >
                              <option value="facebook">Facebook</option>
                              <option value="google">Google</option>
                              <option value="yelp">Yelp</option>
                              <option value="Instagram">Instagram</option>
                              <option value="Friend/Family">
                                Friend / Family
                              </option>
                              <option value="Next-door">Next Door</option>
                              <option value="Repeat-Customer">
                                Repeat Customer
                              </option>
                              <option value="other">Other</option>
                            </select>
                          </div>
                        </div>
                      )}
                      {isDirectRequest && (
                        <div className="col-12 col-sm-6"></div>
                      )}
                      <div className="col-12 col-sm-6">
                        <div className="form-group button-wrapper">
                          <button className="custom-buton custom-buton-large w-100">
                            Sign Up
                          </button>
                          <p className="light-grey-color text-center small-font-size pt-3">
                            *all fields required
                          </p>
                        </div>
                        <div className="no-account-text-wrapper-custom text-center mt-4 pt-4">
                          <p className="light-grey-color">
                            Already have an account?{" "}
                            {reqPostData ? (
                              <Link
                                onClick={() => setConfirmScreen("login")}
                                className="dark-grey-color"
                              >
                                Log In
                              </Link>
                            ) : (
                              <Link
                                to={{
                                  pathname: "/login",
                                  state: reqPostData,
                                }}
                                className="dark-grey-color"
                              >
                                Log In
                              </Link>
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="no-account-text-wrapper-custom text-center mt-4 pt-4 mt-sm-5 pt-sm-5"></div>
      </div>
      {reqPostData && (
        <div className="next-prev">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-7 col-md-4">
              <div className="float-left">
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => setConfirmScreen("")}
                  className="dark-grey-color prev"
                >
                  <img src={greyBackArrowImage} /> Prev
                </div>
              </div>

              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default withRouter(Register);
